import { z } from "zod";
export const sendEmailSchema = z.object({
    to: z.email({ message: "Inserire un indirizzo email valido" }),
    name: z.string().min(2).max(100).optional(),
    cc: z.email({ message: "Inserire un indirizzo email valido" }).optional(),
    ccn: z.email({ message: "Inserire un indirizzo email valido" }).optional(),
    body: z.object({
        addressee: z.string().optional(),
        customerCompanyName: z.string().optional(),
        customerCompanyWebsite: z.string().optional(),
        customerName: z.string().optional(),
        leadCompanyName: z.string().optional(),
        appointmentDate: z.string().optional(),
        // commercialName: z.string().optional(),
        teamLeaderName: z.string().optional(),
        reason: z.string().optional(),
        oldAppointmentDate: z.string().optional(),
        appointmentTime: z.string().optional(),
        website: z.string().optional()
    }),
})

export type SendEmailFormValues = z.infer<typeof sendEmailSchema>;

export const templateSchema = z.object({
    fromEmail: z.email({ message: "Inserire un indirizzo email valido" }),
    fromEmailName: z.string({ message: "Inserire un nome valido" }),
    templateName: z.string({ message: "Inserire un nome valido" }),
    templateHTML: z.string({ message: "Inserire un contenuto valido" }),
    templateText: z.string({ message: "Inserire un contenuto valido" }),
    subject: z.string({ message: "Inserire un oggetto valido" }),
    projectId: z.string({ message: "Inserire un ID progetto valido" })
})

export type TemplateFormValues = z.infer<typeof templateSchema>;